<template>
    <button
        v-tippy="t('editorToggleSubscript')"
        :class="[
            buttonState(
                editor.can().toggleSubscript() && editorSelection.text.length > 0,
                editor.isActive('subscript'),
            ),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().toggleSubscript() || editorSelection.text.length === 0"
        @click="editor.chain().focus().toggleSubscript().run()"
    >
        <MdiFormatSubscript class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import { MdiFormatSubscript } from 'materialdesignicons-vue3/icons/';

    defineExpose({
        name: 'SubscriptTextButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
        editorSelection: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
    const editorSelection = props.editorSelection;
</script>
